export function testimonialsSlider() {
    const isTouch = this.isTouch;

    $(".testimonials-slider").each(function() {
        const sliderWrapItem = $(this);
        const slider = sliderWrapItem.find(".slides");
        const sliderControls = sliderWrapItem.find(".slider-controls");

        slider.slick({
            infinite: false,
            slidesToScroll: 1,
            variableWidth: true,
            appendArrows: sliderControls,
            prevArrow: `<button class="slick-prev slick-arrow button arrow" aria-label="Prev" type="button"><svg viewBox="0 0 19 20"><path d="M18.3929 10L6.30886 15.9927L9.61622 10.001L6.30886 4.00732L18.3929 10Z"></path></svg></button>`,
            nextArrow: `<button class="slick-next slick-arrow button arrow" aria-label="Next" type="button"><svg viewBox="0 0 19 20"><path d="M18.3929 10L6.30886 15.9927L9.61622 10.001L6.30886 4.00732L18.3929 10Z"></path></svg></button>`
        });

        $(window).on("load", function() {
            if(isTouch) {
                const slidesAmount = slider.find(".slide").length;
                const slideCounterTemplate = `<strong class="cur-slide">1</strong><span class="divider"></span><strong>${slidesAmount}</strong>`;
        
                $(slideCounterTemplate).insertAfter(sliderControls.find(".slick-prev"));
            }

            slider.on("afterChange", function (event, slick, currentSlide, nextSlide) {
                sliderWrapItem.find(".cur-slide").text(currentSlide + 1);
            });
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonials-slider.js